import React, {memo, useMemo} from 'react';
import {Card, Col, Row} from 'tea-component';
import classNames from 'classnames';
import {useIntl} from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
// import { ADD_DASHBOARD_CONFIG } from './constants';
import {Guide} from '@/pages/home/components/Guide';
import {useSearchParamsState} from '@/pages/aigc/hooks/useQuery';
import {useStore} from '@/pages/aigc/hooks/useContext/useStore';
import {DATALAB_EDITOR} from '@dbl/core/global';
import './index.scss';
import tapToSelectEn from '@/pages/datalab/assets/img/home/tapToSelectEn.png';
import clickCalculateEn from '@/pages/datalab/assets/img/home/clickCalculateEn.png';
import dragDateEn from '@/pages/datalab/assets/img/home/dragDateEn.png';
import tapPublishEn from '@/pages/datalab/assets/img/home/tapPublishEn.png';
import tapToSelectCn from '@/pages/datalab/assets/img/home/tapToSelectCn.png';
import clickCalculateCn from '@/pages/datalab/assets/img/home/clickCalculateCn.png';
import dragDateCn from '@/pages/datalab/assets/img/home/dragDateCn.png';
import tapPublishCn from '@/pages/datalab/assets/img/home/tapPublishCn.png';
import customDashBoardNameCn from '@/pages/datalab/assets/img/home/customDashBoardNameCn.png';
import tapFiltertextCn from '@/pages/datalab/assets/img/home/tapFiltertextCn.png';
import dargSildbarCn from '@/pages/datalab/assets/img/home/dargSildbarCn.png';
import addChartCn from '@/pages/datalab/assets/img/home/addChartCn.png';
import customDashBoardNameEn from '@/pages/datalab/assets/img/home/customDashBoardNameEn.png';
import tapFiltertextEn from '@/pages/datalab/assets/img/home/tapFiltertextEn.png';
import dargSildbarEn from '@/pages/datalab/assets/img/home/dargSildbarEn.png';
import addChartEn from '@/pages/datalab/assets/img/home/addChartEn.png';
import withDelayWrapper from '@/pages/intelligence/components/UserGuide/DelayWrapper';
import {LANGUAGE_EN} from "@home/_config/config";
import {storage} from '@/utils/utils';
import {useIsShowGuide} from './hoooks';

// 常量
export const ADD_DASHBOARD = 'addDashboard';
export const ADD_ANALYSIS = 'addAnalysis';
export const SHARE_DASHBOARD = 'shareDashboard';

// 路径必须加helpType
type AddSlashIfString<T> = T extends string ? `${T}?helpType=${LinkType}` : T;

// 交集
export type LinkType =
  | typeof ADD_DASHBOARD
  | typeof ADD_ANALYSIS
  | typeof SHARE_DASHBOARD;

type IGettingProps = {
  // 游戏业务名称
  gameCode: string | undefined;
  // 跳转链接时权限验证
  privilegesLink: (path: string, privileges: string[]) => void;
};

type GettingStartItem<S = string> = {
  // 列表key
  key: LinkType;
  // 英文名称
  titleEn: S;
  // 中文名称
  titleCn: S;
  // 英文描述
  descEn: S;
  // 中文描述
  descCn: S;
  // 跳转地址
  linkUrl: AddSlashIfString<S>;
  // 权限
  privileges: string[];
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const gettingStartList: GettingStartItem[] = [
  {
    titleEn: 'Create a Dashboard',
    titleCn: '创建报表',
    descEn: 'Create a new Dashboard on Dashboard page.',
    descCn: '在报表页面上创建一个新的报表。',
    key: ADD_DASHBOARD,
    linkUrl: `/WorkBench/MyDashboard/CreateDashboard?helpType=${ADD_DASHBOARD}&redirect=${`Home`}`,
    privileges: [DATALAB_EDITOR.AddDashboardBtn],
  },
  {
    titleEn: 'Add Charts',
    titleCn: '添加图表',
    descEn: "Set the data source and calculation conditions, click 'Calculate' to generate the chart, save and add it to the Dashboard.",
    descCn: "设置数据源和计算条件，点击“计算”生成图表，保存并将其添加到报表。",
    key: ADD_ANALYSIS,
    linkUrl: `/Analysis/MultiAnalysis?helpType=${ADD_ANALYSIS}`,
    privileges: [DATALAB_EDITOR.AddChartBtn],
  },
  {
    titleEn: 'Share/Publish Dashboard',
    titleCn: '分享/发布报表',
    descEn: 'You can share your Dashboard or publish it.',
    descCn: '你可以保存你的报表或发布。',
    key: SHARE_DASHBOARD,
    linkUrl: `/WorkBench/MyDashboard?helpType=${SHARE_DASHBOARD}`,
    privileges: [DATALAB_EDITOR.Dashbord],
  },
];
export default function GettingStart({
  privilegesLink,
  // gameCode,
}: IGettingProps) {
  // 中英文
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  // 全局上下文Key
  const [guidanceValue = []] = useStore<Array<string>>('useGuidanceNum', []);
  // 是否还显示新手引导
  const {isShowGuide} = useIsShowGuide();
  // 列表跳转
  // const handleOpenLinkSystem = (linkUrl: string) =>
  //   history.push(`/datalab/${gameCode}${linkUrl}`);
  const handleOpenLinkSystem =(linkUrl: string, privileges: string[],) => privilegesLink(linkUrl, privileges);
  return (
    <Card>
      <Card.Body title={formatMessage({id: 'dbl_home_getting_start_title'})} className={'dbl-home-getting-start-body'}>
        <Row>
          {gettingStartList.map((task, index) => (
            <Col span={8} key={task.key}>
              <div className={'dbl-home-card-get-container'} onClick={() => handleOpenLinkSystem(task.linkUrl, task.privileges)}>
                <span
                  className={classNames('dbl-home-card-get-container-index', {
                    'dbl-home-card-get-container-active':
                      !isShowGuide || guidanceValue.includes(task.key),
                  })}
                >
                  {!isShowGuide || guidanceValue.includes(task.key) ? (
                    <SvgIcon type="action-right" />
                  ) : (
                    index + 1
                  )}
                </span>
                <span className={'dbl-home-card-get-container-title'}>
                  {isEn ? task.titleEn : task.titleCn}
                </span>
              </div>
              <div className="container">
                {isEn ? task.descEn : task.descCn}
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
}

export const GlobalPositioningGuidanceHome = memo(() => {
  const [subTab, setSearchParamsState] = useSearchParamsState('helpType', '');
  // 中英文
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  
  const [guidanceValue = [], setGuidanceValue] = useStore<Array<string>>(
    'useGuidanceNum',
    [],
  );
  const {isShowGuide, noShowList, userid} = useIsShowGuide();
  const isHidden = subTab && isShowGuide;
  const guideConfig: Record<LinkType, unknown> = useMemo(() => {
    const ADD_DASHBOARD_CONFIG = [
      {
        highlightElements: [
          {
            element: document.querySelector(`.dbl-chart-nodata-btn`),
            padding: {
              paddingTop: 6,
              paddingRight: 6,
              paddingBottom: 6,
              paddingLeft: 6,
            },
            hasRadius: true,
            extImage: {
              image: isEn ? addChartEn : addChartCn,
              placement: 'top-end',
              style: {
                position: 'absolute',
                bottom: '50px',
                left: '-35px',
                width: isEn ? '203px' : '180px',
              },
            },
          },
          {
            element: document.querySelector(`.dbl-right-modal-tabs`),
            hasRadius: true,
            extImage: {
              image: isEn ? tapFiltertextEn : tapFiltertextCn,
              style: {
                right: '-50px',
                position: 'absolute',
                width: isEn ? '496px' : '473px',
              },
            },
            padding: {
              paddingLeft: -10,
              paddingRight: isEn ?  -120 :  -220 ,
            }
          },
          {
            element: document.querySelector(
              `.ReactVirtualized__Grid__innerScrollContainer div:first-child`,
            ),
            hasRadius: true,
            extImage: {
              image: isEn ? dargSildbarEn : dargSildbarCn,
              style: {
                right: '-50px',
                position: 'absolute',
                width: isEn ? '480px' : '334px',
                top: '-10px',
              },
            },
            padding: {
              paddingLeft: -1,
              paddingRight: 3,
              paddingBottom: -8,
              paddingTop: 8,
            },
          },
        ],
        extImage: {
          image: isEn ? customDashBoardNameEn : customDashBoardNameCn,
          style: {
            left: '95px',
            position: 'absolute',
            width: isEn ? '480px' : '246px',
            top: '-10px',
          },
        },
        element: () => document.querySelector(`.dbl-datalab-guide-title`),
        padding: {
          paddingLeft: 5,
          paddingRight: 5,
        },
      },
    ];
    const ADD_ANALYSIS_CONFIG = [
      {
        highlightElements: [
          {
            element: document.getElementById(
              `multi-analysis-search-filtration`,
            ),
            hasRadius: true,
            padding: {
              paddingBottom: -5,
              paddingTop: -5,
            },
            extImage: {
              image: isEn ? dragDateEn : dragDateCn,
              style: {
                left: '-62px',
                bottom: '-290px',
                position: 'absolute',
                width: isEn ? '896px' : '654px',
              },
            },
          },
          {
            element: document.querySelector(`.db-datalab-guide-left-container`),
            hasRadius: true,
            extImage: {
              image: isEn ? tapToSelectEn : tapToSelectCn,
              style: {
                position: 'absolute',
                width: isEn ? '281px' : '205px',
                top: '-210px',
                right: '-250px',
              },
            },
            padding: {
              paddingTop: 10,
              paddingRight: 20,
              paddingBottom: -10,
              paddingLeft: 20,
            },
          },
          {
            element: document.querySelectorAll('.field_list .field_list-bd')[1],
            hasRadius: true,

            padding: {
              paddingTop: 0,
              paddingRight: 20,
              paddingBottom: 5,
              paddingLeft: 20,
            },
          },
        ],
        extImage: {
          image: isEn ? clickCalculateEn : clickCalculateCn,
          placement: 'left',
          style: {
            position: 'absolute',
            top: '-10px',
            right: '-70px',
            width: isEn ? '329px' : '262px',
          },
        },
        element: () =>
          document.querySelector(
            '.tea-form-operate.form-action span:first-child',
          ),
        padding: {
          paddingTop: 8,
          paddingRight: -2,
          paddingBottom: 8,
          paddingLeft: 8,
        },
        placement: 'bottom-center',
        placementOffset: [0, 10],
      },
    ];
    const SHARE_DASHBOARD_CONFIG = [
      {
        extImage: {
          image: isEn ? tapPublishEn : tapPublishCn,
          placement: 'top',
          style: {
            position: 'absolute',
            top: '-100px',
            right: isEn ? '-150px' : '-100px',
            width: isEn ? '321px' : '200px',
          },
        },
        element: () => document.querySelector('.db-datalab-guide-btn'),
        padding: {
          paddingTop: 5,
          paddingRight: 10,
          paddingBottom: 5,
          paddingLeft: 10,
        },
        placement: 'top',
      },
    ];
    const list = {
      [ADD_DASHBOARD]: ADD_DASHBOARD_CONFIG,
      [ADD_ANALYSIS]: ADD_ANALYSIS_CONFIG,
      [SHARE_DASHBOARD]: SHARE_DASHBOARD_CONFIG,
    };
    return (list as any)?.[subTab];
  }, [isEn, subTab]);

  const valueConfig: { [key in string]: string } = {
    [ADD_DASHBOARD]: ADD_DASHBOARD,
    [ADD_ANALYSIS]: ADD_ANALYSIS,
    [SHARE_DASHBOARD]: SHARE_DASHBOARD,
  } as const;

  const handleOnClickOffGuidance = () => {
    setSearchParamsState('', { isReplace: true });
    setGuidanceValue([
      ...new Set([...(guidanceValue || []), valueConfig[subTab]]),
    ]);
  };

  const handleOnClickNotShow = () => {
    setSearchParamsState('', { isReplace: true });
    setGuidanceValue([
      ...new Set([...(guidanceValue || []), valueConfig[subTab]]),
    ]);
    /**
     * 主页中有三个页面的新手指引
     *  旧需求: 点击某个页面新手指引的 Skip 按钮时, 只有该页面的新手指引下一次不会显示, 其他页面的新手指引下次还会显示
     *  新需求: 点击某个页面新手指引的 Skip 按钮时, 所有三个页面的新手指引下一次都不会显示
     *
     * 旧的开发方案:
     *    noShowList: { userid用户id: [ADD_DASHBOARD, ADD_ANALYSIS, SHARE_DASHBOARD] }
     *    每次点击 Skip 按钮时, 都会更新 noShowList中的该用户id对应的值, 该用户id对应的值是该页面的新手指引id
     * 新的开发方案:
     *    每次点击 Skip 按钮时, 直接将三个页面新手指引id [ADD_DASHBOARD, ADD_ANALYSIS, SHARE_DASHBOARD] 更新到noShowList中的该用户id对应的值
     */
    const newNoShowList = noShowList || {} as any;
    newNoShowList[userid] = [ADD_DASHBOARD, ADD_ANALYSIS, SHARE_DASHBOARD];
    
    storage.setItem('__dbl_guide_notShow_list', JSON.stringify(newNoShowList));
  };

  if (!isHidden) return <></>;
  return (
    <Guide
      visibleTriangleArrow={false}
      visible={!!isHidden}
      nextButtonTheme="primary"
      steps={guideConfig as any}
      maskOpacity={0.6}
      CustomBodyElement={
        <div
          className="dbl-home-card-get-container-guidance-btn"
          
        >
          <div 
            className="dbl-home-card-get-container-guidance-btn-item" 
            onClick={handleOnClickOffGuidance}
          >
            {formatMessage({id: 'dbl_home_getting_start_know'})}
          </div>
          <div 
            className="dbl-home-card-get-container-guidance-btn-item" 
            style={{marginLeft: 10}}
            onClick={handleOnClickNotShow}
          >
            {formatMessage({id: 'dbl_home_getting_start_not_show'})}
          </div>  
        </div>
      }
    />
  );
});
// 静态数据加载态
export const GlobalPositioningGuidance = withDelayWrapper(
  GlobalPositioningGuidanceHome,
);